import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function TheProblem() {
  const problems = [{
    title: 'Tiendas genéricas',
    desc: 'Te ofrecen tallas estándar para cuerpos estándar.'
  }, {
    title: 'Tiendas online',
    desc: 'Te muestran fotos perfectas y te entregan algo completamente diferente.'
  }, {
    title: 'Marcas masivas',
    desc: 'Te venden lo que está de moda — no lo que te funciona a ti.'
  }];
  return <section className="py-14 bg-cream-50" data-id="element-284">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-285">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-286">
          <h2 className="text-3xl md:text-4xl font-display text-charcoal mb-4" data-id="element-287">
            El problema no es tu estilo — es tu acceso
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-288">
          {problems.map((prob, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-cream-100 p-8 text-center border border-cream-200" data-id="element-289">
              <XCircleIcon className="h-8 w-8 text-terracotta-400 mx-auto mb-4" strokeWidth={1.5} data-id="element-290" />
              <h3 className="text-xl font-display text-charcoal mb-3" data-id="element-291">
                {prob.title}
              </h3>
              <p className="text-charcoal/70 font-light" data-id="element-292">{prob.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-center" data-id="element-293">
          <p className="text-xl text-charcoal/80 font-light mb-2" data-id="element-294">
            Y el resultado es siempre el mismo:
          </p>
          <p className="text-3xl font-display text-terracotta-500" data-id="element-295">
            Gastas. Acumulas. Y no avanzas.
          </p>
        </motion.div>
      </div>
    </section>;
}